import React, { useLayoutEffect, useState } from "react";
import { useRouteError } from "react-router-dom";

const MESSAGES = {
    404: {
        title: "Page introuvable",
        text: "La page que vous recherchez n'existe pas ou a été déplacée."
    },
    403: {
        title: "Accès refusé",
        text: "Vous n'avez pas les droits nécessaires pour consulter cette page."
    },
    405: {
        title: "Accès limité",
        text: "Votre abonnement actuel ne vous permet pas d'accéder à cette page."
    },
    500: {
        title: "Une erreur est survenue",
        text: "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer dans quelques instants."
    }
};

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    // Si la coquille (en-tête) est déjà affichée, inutile de répéter le logo.
    const [embedded, setEmbedded] = useState(false);
    useLayoutEffect(() => {
        setEmbedded(!!document.getElementById("header"));
    }, []);

    const status = error?.status;
    const info = MESSAGES[status] || {
        title: "Une erreur est survenue",
        text: error?.statusText || error?.message || "Veuillez réessayer dans quelques instants."
    };

    return (
        <div id="error-page" className={`lk-error${embedded ? " lk-error--embedded" : ""}`}>
            <div className="lk-error__card">
                {!embedded && (
                    <div className="lk-error__brand">
                        <img src="/logo-full.png" alt="Lokapp" />
                    </div>
                )}
                <span className="lk-error__code">{status ? `Erreur ${status}` : "Erreur"}</span>
                <h1>{info.title}</h1>
                <p>{info.text}</p>
                <div className="lk-error__actions">
                    <a className="lk-btn lk-btn--primary" href="/">
                        <i className="pi pi-home" aria-hidden="true"></i>
                        Retour à l'accueil
                    </a>
                    <button type="button" className="lk-btn lk-btn--secondary" onClick={() => window.history.back()}>
                        <i className="pi pi-arrow-left" aria-hidden="true"></i>
                        Page précédente
                    </button>
                </div>
            </div>
        </div>
    );
}
